import AppHeader from 'src/components/AppHeader/AppHeader';
import { Button, Stack, Typography } from '@mui/material';
import { ts } from "src/utils/translate";
import { WelcomeImage } from "src/pages/WelcomePage/WelcomeImage";
import { PlusSvgIcon } from "src/pages/ProjectsPage/icons/PlusIcon";
import { ProjectWizard } from "src/pages/ProjectDetailsWizard/ProjectWizard";
import { useMatch, useNavigate } from "react-router";

export const WelcomePage = (props: {}) => {

    const navigate = useNavigate();

    const matchNew = useMatch("/welcome/new");
    const openProjectWizard = Boolean(matchNew);

  return (
      <>
        <AppHeader/>
        <Stack direction='column' sx={{justifyContent: 'center', alignItems: 'center', height: `calc(100vh - 64px)`}}
               spacing={8}>
          <WelcomeImage style={{width: '462px', height: '462px', cursor: 'pointer'}} onClick={() => navigate("/welcome/new")}/>
          <Stack direction='column' sx={{justifyContent: 'center', alignItems: 'center'}} spacing={1}>
            <Typography
                variant={'h6'}>{ts('welcome_page_text', "You're just a few steps away from your professional electrical plan")}</Typography>
            <Typography
                variant={'body2'}>{ts('welcome_page_sub_text', "Automate your electrical design and create instant quotes with our easy-to-use planner for Loxone, Conventional and IT systems.")}</Typography>
          </Stack>
          <Button variant="contained" startIcon={<PlusSvgIcon/>} onClick={() => navigate("/welcome/new")}>
            {ts('welcome_page_create_new_project', 'Create New Project')}
          </Button>
        </Stack>

          <ProjectWizard
              open={openProjectWizard}
              onClose={() => navigate("/welcome")}
          />
      </>
  )

}